// extracted by mini-css-extract-plugin
export var activeFilterButton = "_sa-c";
export var backButton = "_sa-4";
export var backIcon = "_sa-5";
export var chevronShortcut = "_sa-6";
export var container = "_sa-1";
export var editor = "_sa-8";
export var editorWrapper = "_sa-7";
export var prefix = "_sa-2";
export var searchIcon = "_sa-3";
export var suffix = "_sa-9";
export var suffixContent = "_sa-a";
export var suffixText = "_sa-b";
export var wrapper = "_sa-0";